import { jsx as o, jsxs as a } from "react/jsx-runtime";
import { P as d, T as p } from "../../../toast-BQ1fINv3.js";
import { ToastContext as c } from "./toast.context.js";
import { useToastProvider as h } from "./toast.hook.js";
function v({ children: e, duration: i = 5e3 }) {
  const { activeToast: t, open: r, handleOpenChange: s, showToast: n } = h();
  return /* @__PURE__ */ o(c.Provider, { value: { showToast: n }, children: /* @__PURE__ */ a(d, { swipeDirection: "down", swipeThreshold: 15, duration: i, children: [
    e,
    t && /* @__PURE__ */ o(
      p,
      {
        status: t.status,
        text: t.text,
        open: r,
        onOpenChange: s,
        link: t.link,
        isStatic: t.isStatic
      },
      t.id
    )
  ] }) });
}
export {
  v as ToastProvider
};
